<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<h1 class="part-number">Part I</h1>
<h1 class="part-title">The<br/> 17 Simple Rules<br/> of Financial<br/> Safety</h1></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?0943a753